
export class SurveyListResponse {
    surveyId: number;
    surveyTitle: string;
    requestId: number;
}
export class SurveyDetailResponse {
    surveyBasicInfo: {
        surveyId: number,
        surveyTitle: string
    };
    description: string;
    surveryQuestionInfo?: (SurveyQuestionInfo)[] | null;
    relatedRequestInfo?: (RelatedRequestInfo) | null;
    anonymousReply: boolean;
}

export class SurveyQuestionInfo {
    surveryQsId: number;
    branchOption: number;
    branchQsId: number;
    description: string;
    required: boolean;
    responses?: [] | null;
    scale: number;
    answerTypeName: string;
}
export class RelatedRequestInfo {
    closeTime: string;
    closingTechnicianName: string;
    description: string;
    openTime: string;
    slaAchieved: boolean;
    requestType: number;
    solutionText: string;
}
export class SurveyResponse {
    surveyId: number;
    requestId: number;
    anonymousReply: number;
    surveyResponseValues?: (SurveyResponseValue)[] | null;
}

export class SurveyResponseValue {
    questionId: number;
    answer: string;
}



